<div class="c-chat-box__item c-chat-box__item--primary">
  <table class="dynamic-table" *ngIf="content.length > 0">
    <thead>
    <tr>
      <th *ngFor="let col of getTableHeaders(content)">{{ col }}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let row of content; let i = index">
      <td *ngFor="let col of getTableHeaders(content)" [attr.data-label]="col">{{ row[col] }}</td>
    </tr>
    </tbody>
  </table>
</div>
